import { STATUSI } from '../lib/konstante';

export default function StatusTocke({ status }) {
  return (
    <span className={`status status-${status}`}>
      <i />
      {(STATUSI[status] ?? STATUSI.ne).naziv}
    </span>
  );
}
